// extracted by mini-css-extract-plugin
module.exports = {"buttons":"EditAreaModal_buttons__1vMNS","error":"EditAreaModal_error__3vmOn","error-msg":"EditAreaModal_error-msg__tmBa2"};